/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Completion } from '../models/Completion';
import type { InitUploadRequest } from '../models/InitUploadRequest';
import type { InitUploadResponse } from '../models/InitUploadResponse';
import type { PatchCompletionRequest } from '../models/PatchCompletionRequest';
import type { PostVideoCompletionRequest } from '../models/PostVideoCompletionRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompletionsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Initialize a video upload for a completion recording
     * Create a bare video record (no library exercise attached) and get an upload URL. Use /exercises/init-upload instead when adding to the exercise library.
     * @returns InitUploadResponse Upload initialized successfully
     * @throws ApiError
     */
    public postCompletionsInitUpload({
        requestBody,
    }: {
        requestBody?: InitUploadRequest,
    }): CancelablePromise<InitUploadResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/completions/init-upload',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden - insufficient permissions`,
            },
        });
    }

    /**
     * Mark an exercise as complete
     * @returns Completion Completion created
     * @throws ApiError
     */
    public postCompletionsStandalone({
        requestBody,
    }: {
        requestBody: {
            targetId: string;
            painScore: number | null;
            notes: string | null;
        },
    }): CancelablePromise<Completion> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/completions/standalone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Program video not found`,
            },
        });
    }

    /**
     * Mark an exercise as complete
     * @returns Completion Completion created
     * @throws ApiError
     */
    public postCompletions({
        requestBody,
    }: {
        requestBody: PostVideoCompletionRequest,
    }): CancelablePromise<Completion> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/completions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Program video not found`,
            },
        });
    }

    /**
     * Get completions for one or more programs, optionally within a date range
     * @returns Completion List of completions
     * @throws ApiError
     */
    public getCompletions({
        programIds,
        userId,
        dateFrom,
        dateTo,
        minPain,
    }: {
        /**
         * Comma-separated list of program UUIDs
         */
        programIds?: string,
        userId?: string,
        /**
         * Inclusive start instant (ISO datetime). Callers should convert their local day boundary to UTC before sending.
         */
        dateFrom?: string,
        /**
         * Inclusive end instant (ISO datetime). Callers should convert their local day boundary to UTC before sending.
         */
        dateTo?: string,
        minPain?: number | null,
    }): CancelablePromise<Array<Completion>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/completions',
            query: {
                'programIds': programIds,
                'userId': userId,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'minPain': minPain,
            },
            errors: {
                400: `Requested programs belong to different clients`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Program not found`,
            },
        });
    }

    /**
     * Update a completion's pain score or notes
     * @returns Completion Completion updated
     * @throws ApiError
     */
    public patchCompletions({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: PatchCompletionRequest,
    }): CancelablePromise<Completion> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/completions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }

    /**
     * Undo a completion (same-day only)
     * @returns void
     * @throws ApiError
     */
    public deleteCompletions({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/completions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                422: `Outside same-day window`,
            },
        });
    }

    /**
     * Share or unshare a completion's video with the trainer (owner only)
     * @returns Completion Completion updated
     * @throws ApiError
     */
    public patchCompletionsShare({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: {
            shared: boolean;
        },
    }): CancelablePromise<Completion> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/completions/{id}/share',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }

    /**
     * Mark a shared completion as reviewed (linked trainer only)
     * @returns Completion Completion marked reviewed
     * @throws ApiError
     */
    public patchCompletionsReview({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            reviewNote?: string | null;
        },
    }): CancelablePromise<Completion> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/completions/{id}/review',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }

}
